import './App.css';

import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';

import image02 from './images/HP01.jpg';

function EasyMqPageSummary() {

    return (
        <div>
            <Card>
                <CardContent >
                    <p className="Tab-Section-body" >
                        GDS Easy MQ is a high-performance universal messaging library designed for distributed and concurrent applications.
                        It functions as an embeddable networking library that sends and receives atomic messages across various transports like
                        Named Pipe, TCP, Secure TCP and UDP.
                    </p>
                    <br />

                    <p className="Tab-Section-body-purple" >
                        Brokerless Architecture:
                    </p>
                    <p className="Tab-Section-body" >
                        Easy MQ operates without a dedicated message broker.
                    </p>
                    <br />

                    <p className="Tab-Section-body-purple" >
                        Asynchronous Messaging:
                    </p>
                    <p className="Tab-Section-body" >
                        Easy MQ utilizes an asynchronous I/O model, enabling scalable multicore applications built as asynchronous message-processing tasks.
                    </p>
                    <br />

                    <p className="Tab-Section-body-purple" >
                        High Performance:
                    </p>
                    <p className="Tab-Section-body" >
                        It is designed for speed and efficiency, making it suitable for use as a communication fabric in clustered products.
                    </p>
                    <br />

                    <p className="Tab-Section-body-purple" >
                        Transport Flexibility:
                    </p>
                    <p className="Tab-Section-body" >
                        Easy MQ supports multiple transport protocols, including Named Pipe, TCP, Secure TCP and UDP.
                    </p>
                    <br />

                    <p className="Tab-Section-body-purple" >
                        Easy To Use:
                    </p>
                    <p className="Tab-Section-body" >
                        It is super easy to setup a server, create/shut down connection, and send and receive messages via Easy MQ.
                    </p>
                    <br />
                </CardContent>
            </Card>
            <br />
        </div>
    );
}

export default EasyMqPageSummary;
